<template>
  <v-fade-transition>
    <v-sheet
      v-if="$vuetify.breakpoint.mdAndUp"
      class="elevation-6"
      style="border-radius: 10px; height: auto; width: 240px; z-index: 1000; position: absolute; top: 10px; right: 10px;"
      absolute
      top
      right
    >
      <v-container
        v-show="!measurementTypeSelected"
        grid-list-md
        text-xs-center
      >
        <v-layout align-center justify-end>
          <h2>Måleverktøy</h2>
          <v-spacer></v-spacer>
          <v-btn
            fab
            small
            right
            flat
            outline
            color="gray"
            @click="resetAndClose"
          >
            <v-icon style="font-size: 24px; " dark>close</v-icon>
          </v-btn>
        </v-layout>
        <v-layout align-center justify-space-around column fill-height>
          <v-btn
            round
            dark
            class="pa-2"
            outline
            block
            color="blue"
            @click="loadMeasurement('length')"
          >
            <v-icon left dark>mdi-ruler</v-icon> Mål avstand
          </v-btn>
          <v-btn
            block
            class="pa-2"
            round
            outline
            color="blue"
            @click="loadMeasurement('area')"
          >
            <v-icon left dark>mdi-texture-box</v-icon> Mål areal
          </v-btn>
        </v-layout>
      </v-container>
      <v-container v-show="measurementTypeSelected" grid-list-md text-xs-center>
        <v-layout align-start justify-end row>
          <v-btn
            :disabled="measurementState === 'measuring'"
            block
            round
            outline
            color="red"
            @click="newMeasurement(measurementTypeSelected)"
          >
            Ny måling</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn fab small flat outline color="gray" @click="resetAndClose">
            <v-icon style="font-size: 24px; " dark>close</v-icon>
          </v-btn>
        </v-layout>
        <v-layout align-start justify-start column fill-height>
          <label
            v-show="measurementLabel == null && loaded"
            style="margin-left: 10px; font-size: 20px;"
            >{{ infoText }}</label
          >
          <v-progress-circular
            class="ml-4"
            v-show="!loaded"
            indeterminate
            color="primary"
          ></v-progress-circular>

          <template v-if="!is3d && measurementLabel">
            <label
              v-if="measurementTypeSelected == 'length'"
              style="margin-left: 10px; font-size: 20px;"
              >{{ measurementLabel }}</label
            >
            <label
              v-if="measurementTypeSelected == 'area'"
              style="margin-left: 10px; font-size: 20px;"
              >Areal: {{ measurementLabel.area }}</label
            >
            <label
              v-if="
                measurementTypeSelected == 'area' && measurementLabel !== null
              "
              style="margin-left: 10px; font-size: 20px;"
              >Omkrets: {{ measurementLabel.perimeter }}</label
            >
          </template>
          <template
            v-if="
              is3d && measurementTypeSelected == 'length' && measurementLabel
            "
          >
            <label style="margin-left: 10px; font-size: 16px;">{{
              "Direkte: " + measurementLabel.directDistance.text
            }}</label>
            <label style="margin-left: 10px; font-size: 16px;">{{
              "Horisontal: " + measurementLabel.horizontalDistance.text
            }}</label>
            <label style="margin-left: 10px; font-size: 16px;">{{
              "Vertikal: " + measurementLabel.verticalDistance.text
            }}</label>
          </template>
          <template
            v-if="is3d && measurementTypeSelected == 'area' && measurementLabel"
          >
            <label
              v-if="measurementLabel.area.state !== 'available'"
              style="margin-left: 10px; font-size: 16px;"
              >Dobbeltklikk for å avslutte målingen.</label
            >
            <label
              v-if="measurementLabel.area.state == 'available'"
              style="margin-left: 10px; font-size: 16px;"
              >Areal: {{ measurementLabel.area.text }}</label
            >
            <label
              v-if="measurementLabel.area.state == 'available'"
              style="margin-left: 10px; font-size: 16px;"
              >Omkrets: {{ measurementLabel.perimeterLength.text }}</label
            >
          </template>
          <div v-if="measurementTypeSelected == 'area'"></div>
        </v-layout>
      </v-container>
    </v-sheet>
    <v-toolbar absolute style="z-index: 100" v-else>
      <v-toolbar-items v-if="!measurementTypeSelected">
        <v-btn flat small color="primary" @click="loadMeasurement('length')">
          <v-icon left dark>esri-icon-measure-line</v-icon>Avstand
        </v-btn>

        <v-btn flat small color="primary" @click="loadMeasurement('area')">
          <v-icon left dark>esri-icon-measure-area</v-icon>Areal
        </v-btn>
      </v-toolbar-items>
      <v-toolbar-items v-else>
        <label class="pt-3" v-if="measurementLabel == null">{{
          infoText
        }}</label>
        <v-btn
          v-else
          small
          flat
          color="red"
          @click="newMeasurement(measurementTypeSelected)"
        >
          Ny måling</v-btn
        >
      </v-toolbar-items>
      <v-spacer />

      <v-btn fab small flat color="gray" @click="resetAndClose">
        <v-icon dark>close</v-icon>
      </v-btn>
    </v-toolbar>
  </v-fade-transition>
</template>

<script>
import { loadModules } from "esri-loader";
import { mapState, mapActions } from "vuex";
export default {
  name: "MapMeasure",
  data: function() {
    return {
      areaMeasurement2DWidget: null,
      measurementLabel: null,
      infoText: "Klikk i kartet for å starte måling",
      measurementTypeSelected: false,
      measurementState: null,
      loaded: false,
    };
  },

  computed: {
    ...mapState(["is3d"]),
  },
  watch: {
    is3d(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.resetAndClose();
      }
    },
  },
  methods: {
    ...mapActions(["deactivateTool", "setShowPopupsOnClick"]),
    newMeasurement: function() {
      this.setShowPopupsOnClick(false);
      this.currentMapMeasureViewModel.viewModel.start();
    },
    clearMeasurement: function() {
      this.currentMapMeasureViewModel.view = null;
      this.measurementLabel = "";
      this.infoText = "Trykk i kartet for å starte måling";
    },
    reset: function() {
      if (this.currentMapMeasureViewModel) {
        this.currentMapMeasureViewModel.viewModel.clear();
        this.currentMapMeasureViewModel.viewModel.destroy();
      }
    },
    resetAndClose: function() {
      this.setShowPopupsOnClick(true);
      this.reset();
      this.deactivateTool("measure");
      this.measurementTypeSelected = false;
    },
    getCurrentView: function() {
      return this.is3d ? this.$theSceneViewObject : this.$theMapViewObject;
    },
    loadMeasurement: function(measurementType) {
      this.loaded = false;
      this.measurementTypeSelected = measurementType;

      if (this.measurementTypeSelected == "length") {
        if (this.is3d) {
          this.load3dLineMeasurement();
        } else {
          this.load2dLineMeasurement();
        }
      } else {
        if (this.is3d) {
          this.load3dAreaMeasurement();
        } else {
          this.load2dAreaMeasurement();
        }
      }

      // this.newMeasurement();
    },
    setMapMeasureStateWatcher: function() {
      this.currentMapMeasureViewModel.viewModel.watch(
        "state",
        function(state) {
          this.measurementState = state;
        }.bind(this)
      );
    },
    load3dAreaMeasurement() {
      loadModules(["esri/widgets/AreaMeasurement3D"]).then(
        ([AreaMeasurement3D]) => {
          this.currentMapMeasureViewModel = new AreaMeasurement3D({
            view: this.getCurrentView(),
            unit: "metric",
          });
          this.currentMapMeasureViewModel.viewModel.watch(
            "measurement",
            function(measurementLabel) {
              this.measurementLabel = measurementLabel;
            }.bind(this)
          );
          this.setMapMeasureStateWatcher();
          this.newMeasurement();
          this.loaded = true;
        }
      );
    },
    load3dLineMeasurement() {
      loadModules(["esri/widgets/DirectLineMeasurement3D"]).then(
        ([DirectLineMeasurement3D]) => {
          this.currentMapMeasureViewModel = new DirectLineMeasurement3D({
            view: this.getCurrentView(),
            unit: "metric",
          });
          this.currentMapMeasureViewModel.viewModel.watch(
            "measurement",
            function(measurementLabel) {
              this.measurementLabel = measurementLabel;
            }.bind(this)
          );
          this.setMapMeasureStateWatcher();
          this.newMeasurement();
          this.loaded = true;
        }
      );
    },
    load2dAreaMeasurement() {
      loadModules(["esri/widgets/AreaMeasurement2D"]).then(
        ([AreaMeasurement2D]) => {
          this.currentMapMeasureViewModel = new AreaMeasurement2D({
            view: this.getCurrentView(),
            unit: "metric",
          });
          this.currentMapMeasureViewModel.viewModel.watch(
            "measurementLabel",
            function(measurementLabel) {
              this.measurementLabel = measurementLabel;
            }.bind(this)
          );
          this.setMapMeasureStateWatcher();
          this.newMeasurement();
          this.loaded = true;
        }
      );
    },
    load2dLineMeasurement() {
      loadModules(["esri/widgets/DistanceMeasurement2D"]).then(
        ([DirectLineMeasurement2D]) => {
          this.currentMapMeasureViewModel = new DirectLineMeasurement2D({
            view: this.getCurrentView(),
            unit: "metric",
          });
          this.currentMapMeasureViewModel.viewModel.watch(
            "measurementLabel",
            function(measurementLabel) {
              this.measurementLabel = measurementLabel;
            }.bind(this)
          );
          this.setMapMeasureStateWatcher();
          this.newMeasurement();
          this.loaded = true;
        }
      );
    },
  },
};
</script>

<style></style>
